/* tslint:disable */
import {
  CompanyAccount,
  UserProfile
} from '../index';

declare var Object: any;
export interface PropertyOwnerInterface {
  "property_id": number;
  "property_owner_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  landLord?: UserProfile;
}

export class PropertyOwner implements PropertyOwnerInterface {
  "property_id": number;
  "property_owner_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  landLord: UserProfile;
  constructor(data?: PropertyOwnerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyOwner`.
   */
  public static getModelName() {
    return "PropertyOwner";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyOwner for dynamic purposes.
  **/
  public static factory(data: PropertyOwnerInterface): PropertyOwner{
    return new PropertyOwner(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyOwner',
      plural: 'PropertyOwners',
      path: 'PropertyOwners',
      idName: 'id',
      properties: {
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_owner_id": {
          name: 'property_owner_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        landLord: {
          name: 'landLord',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'property_owner_id',
          keyTo: 'id'
        },
      }
    }
  }
}
